//import Accordion from '@/components/common/AccordionView.vue'
import MembershipCardHome from '@/components/home/MembershipCardHome.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { useAuthStore } from '@/store/auth';
export default {
  name: 'HomeView',
  components: {
    MembershipCardHome
  },
  data() {
    return {
      showBindForm: false,
      phone: '',
      verificationCode: '',
      isSendingCode: false,
      isBinding: false,
      products: [{
        name: '手捣水蜜桃',
        desc: '陈年普洱，醇厚回甘',
        image: require('@/assets/images/products/product1.jpg')
      }, {
        name: '现煲·黑糖珍珠水牛乳茶',
        desc: '花香四溢，清新怡人',
        image: require('@/assets/images/products/product2.jpg')
      }, {
        name: '西瓜顿顿杯',
        desc: '花香四溢，清新怡人',
        image: require('@/assets/images/products/product3.jpg')
      }]
    };
  },
  computed: {
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.phone);
    },
    isFormValid() {
      return this.isPhoneValid && this.verificationCode.length === 6;
    }
  },
  methods: {
    sendCode() {
      this.isSendingCode = true;
      // 发送验证码API调用
      setTimeout(() => {
        this.isSendingCode = false;
      }, 1000);
    },
    bindPhone() {
      this.isBinding = true;
      // 绑定手机号API调用
      setTimeout(() => {
        this.isBinding = false;
        alert('绑定成功！您已成为叶婆手作尊享会员');
        this.showBindForm = false;
      }, 1500);
    },
    initSwiper() {
      this.swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      });
    },
    checkIsLogin() {
      const auth = new useAuthStore();
      if (auth.isWechatAuthorized) {
        window.location.href = window.location.host + "/#/member-center/";
      }
    }
  },
  mounted() {
    this.initSwiper();
    this.checkIsLogin();
  },
  beforeUnmount() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
};